/**
 * LG U+ PC 모듈관련 함수
 */
import axios from 'axios';

const api = axios.create({
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});

function initLguPayment() {
  let _successCallback = null;
  function dataToForm(data) {
    const lgdForm = document.createElement('form');

    for (let key in data) {
      let hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', data[key]);
      lgdForm.appendChild(hiddenField);
    }

    return lgdForm;
  }

  function lguMessageEvent(event) {
    if (event.data.message === 'lguReturn') {
      const param = event.data.param || {};

      const params = new URLSearchParams(param);
      // 정상처리
      if (param['LGD_RESPCODE'] === '0000') {
        api
          .post('/payment/lguPayment.do', params)
          .then((e) => {
            const data = e.data.response;
            if (window.closeIframe) closeIframe();
            if (data != null && data.ERR_YN == 'Y') {
              alert('서비스 이용에 불편을 드려 죄송합니다.\n' + data.ERR_MSG);
              return false;
            }
            if (typeof _successCallback === 'function') {
              _successCallback(data.bundleRvNo);
            }
          })
          .catch((e) => {
            alert('결제요청이 실패하였습니다.\n관리자에게 문의하시기 바랍니다.');
            if (window.closeIframe) closeIframe();
          });
      } else {
        // 비정상종료
        alert(param['LGD_RESPMSG']);
        if (window.closeIframe) closeIframe();
      }
    }
  }

  function lguPaymentLaunch(data, callback) {
    const form = dataToForm(data);
    window.removeEventListener('message', lguMessageEvent);
    window.addEventListener('message', lguMessageEvent);
    _successCallback = callback;
    document.body.appendChild(form);
    openXpay(form, data.CST_PLATFORM, data.LGD_WINDOW_TYPE, null, '', '');
    document.body.removeChild(form);
  }

  return lguPaymentLaunch;
  //return lguMessageEvent;
}

export default initLguPayment();
